export default "__VITE_ASSET__f1dc5eb4__"